import { StringKey } from '../../lang/index';
import { CompanyIndustry } from '../../types/company.types';

export type Perk = {
  banner: string;
  claimType: PerkClaimType;
  contactPerson: string;
  createdAt: Date;
  id: string;
  industry: CompanyIndustry;
  logo: string;
  offerDescription: string;
  offerTypes: null | PerkOfferType[];
  partnerDescription: string;
  partnerName: string;
  partnerShortDescription: string;
  partnerSlogan: string;
  regionsApplicable: string[];
  updatedAt: Date;
  url: string;
};

export enum RegionType {
  COUNTRY = 'region-type:country',
  GROUP = 'region-type:group',
}

export enum PerkClaimType {
  LINK = 'perk-claim-type:link',
  PROMO_CODE = 'perk-claim-type:promo-code',
}

export enum PerkClaimDisplayRule {
  ON_CLICK = 'perk-claim-display-rule:on-click',
  VIA_EMAIL = 'perk-claim-display-rule:via-email',
}

export enum PerkOfferType {
  EXCLUSIVE = 'perk-offer-type:exclusive',
  LIMITED = 'perk-offer-type:limited',
}

export const perkClaimDisplayRuleTranslationKey: Record<PerkClaimDisplayRule, StringKey> = {
  [PerkClaimDisplayRule.ON_CLICK]: 'PERK_CLAIM_DISPLAY_ON_CLICK',
  [PerkClaimDisplayRule.VIA_EMAIL]: 'PERK_CLAIM_DISPLAY_VIA_EMAIL',
};

export const perkClaimDisplayRuleMap = Object.keys(perkClaimDisplayRuleTranslationKey);

export const perkClaimTypeTranslationKey: Record<PerkClaimType, StringKey> = {
  [PerkClaimType.PROMO_CODE]: 'PERK_CLAIM_PROMO_CODE',
  [PerkClaimType.LINK]: 'PERK_CLAIM_LINK',
};

export const perkClaimTypeMap = Object.keys(perkClaimTypeTranslationKey);

export const perkOfferTranslationKey: Record<PerkOfferType, StringKey> = {
  [PerkOfferType.EXCLUSIVE]: 'PERK_OFFER_EXCLUSIVE',
  [PerkOfferType.LIMITED]: 'PERK_OFFER_LIMITED',
};

export const perkOfferTypeOrderMap = Object.keys(perkOfferTranslationKey);

export const perkClaimTypeOrderMap = Object.keys(perkClaimTypeTranslationKey);
